import { Body1, Box, Label2, Link } from '@csp/csp-web-ui';
import { FC } from 'react';
import { StaticContentService } from '../../../common/service/StaticContentService';
import { useTechnicalSupportContactDetails } from '../hook/useTechnicalSupportContactDetails';

export const ContactInformation: FC = () => {
  const contactDetails = useTechnicalSupportContactDetails();
  const contactInformationContent = StaticContentService.getGenericBlock(
    'webHcpTechnicalSupport',
    'contactInformation',
  );

  return (
    <Box mb={3}>
      {contactDetails.phoneNumber && (
        <>
          <Label2 color="textSecondary" fontWeight={700} mb={1}>
            {contactInformationContent.textLabel.label}
          </Label2>
          <Body1 mb={0.5}>{contactDetails.phoneNumber}</Body1>
        </>
      )}
      <Link href={`mailto:${contactDetails.email}`}>{contactDetails.email}</Link>
    </Box>
  );
};
